import { adminApiRequest } from "../../utils/apiUtils";

export const TournamentAdVideoAPI = {
  getVideoList: () => {
    return adminApiRequest.get("/tournament-ad-video/list").then((res) => res);
  },

  registerVideo: (request: FormData) => {
    return adminApiRequest
      .post("/tournament-ad-video", request, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);
  },

  updateVideo: (id: number, request: FormData) => {
    return adminApiRequest
      .put(`/tournament-ad-video/${id}`, request)
      .then((res) => res);
  },

  deleteVideo: (id: number) => {
    return adminApiRequest
      .delete(`/tournament-ad-video/${id}`)
      .then((res) => res);
  },
};
